import { useRef, useState } from 'react';
import { SATIS_FIYATI as T } from '../metin/satisFiyati';
import { paraYaz, satisGirdisiGecerli, tutarYaz } from './mantik';

/**
 * Sonuç tablosunda toplam hücresinde satış fiyatını doğrudan düzenler (03.11.2026). Değer, "Bu teklif için satış
 * fiyatı" alanıyla aynı kayda (satisFiyatlari) yazılır: ölçekleme, PDF ve mesaj mantığı tek kaynaktan gelir.
 * Enter ya da odak çıkışı kaydeder, Esc vazgeçer, boş kayıt sistem fiyatına döner.
 */
export function SatirFiyatDuzenle({ onek, girdi, otelAdi, deger, sistemMinor, para, toplamMinor, salt, degistir }: {
  onek: string;
  girdi: string;
  otelAdi: string;
  /** Kayıtlı yazılan satış fiyatı; yoksa boş. */
  deger: string;
  sistemMinor: number;
  para: string;
  /** Tabloda görünen (uygulanmış) toplam. */
  toplamMinor: number;
  salt: boolean;
  degistir: (girdi: string, v: string) => void;
}) {
  const [duzenleniyor, setDuzenleniyor] = useState(false);
  const [taslak, setTaslak] = useState('');
  const [hata, setHata] = useState(false);
  const vazgecildi = useRef(false);
  const duzenlendi = deger.trim() !== '' && toplamMinor !== sistemMinor;

  const kaydet = () => {
    if (vazgecildi.current) { vazgecildi.current = false; return; }
    if (!satisGirdisiGecerli(taslak)) { setHata(true); return; }
    degistir(girdi, taslak.trim());
    setHata(false);
    setDuzenleniyor(false);
  };

  if (duzenleniyor) {
    return (
      <div className="ht-satir-duzenle">
        <input
          autoFocus
          inputMode="decimal"
          value={taslak}
          aria-label={`${otelAdi}: ${T.etiket} (${para})`}
          aria-invalid={hata}
          placeholder={tutarYaz(sistemMinor)}
          data-testid={`${onek}-satir-fiyat-giris-${girdi}`}
          onChange={(e) => { setTaslak(e.target.value); setHata(false); }}
          onBlur={kaydet}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === 'Enter') { e.preventDefault(); kaydet(); }
            if (e.key === 'Escape') { vazgecildi.current = true; setHata(false); setDuzenleniyor(false); }
          }}
        />
        {hata ? <small className="ht-hata-yazi" role="alert">{T.gecersiz}</small> : null}
      </div>
    );
  }
  return (
    <div className="ht-satir-duzenle">
      <button
        type="button"
        className="ht-baglanti"
        disabled={salt}
        aria-label={`${otelAdi}: ${T.etiket} (${para}), değiştir`}
        data-testid={`${onek}-satir-fiyat-duzenle-${girdi}`}
        onClick={() => { vazgecildi.current = false; setTaslak(deger); setHata(false); setDuzenleniyor(true); }}
      >
        {duzenlendi ? 'Düzenlendi · ' : ''}Fiyatı değiştir
      </button>
      {duzenlendi ? <small className="ht-ipucu" data-testid={`${onek}-satir-sistem-fiyat-${girdi}`}>{T.sistemFiyati(paraYaz(sistemMinor, para))}</small> : null}
      {deger.trim() !== '' && !salt ? <button type="button" className="ht-baglanti" data-testid={`${onek}-satir-fiyat-sifirla-${girdi}`} onClick={() => degistir(girdi, '')}>{T.sifirla}</button> : null}
    </div>
  );
}
